import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import statusCodes from '../statusCodes';

var DatabaseNameMissing = /*#__PURE__*/function (_Error) {
  _inherits(DatabaseNameMissing, _Error);

  var _super = _createSuper(DatabaseNameMissing);

  function DatabaseNameMissing() {
    var _this;

    _classCallCheck(this, DatabaseNameMissing);

    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(params));
    _this.name = 'DatabaseNameMissing';
    _this.message = 'Database name missing.';
    _this.status = statusCodes['Bad Request'];
    return _this;
  }

  return DatabaseNameMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseNameCannotBeBlank = /*#__PURE__*/function (_Error2) {
  _inherits(DatabaseNameCannotBeBlank, _Error2);

  var _super2 = _createSuper(DatabaseNameCannotBeBlank);

  function DatabaseNameCannotBeBlank() {
    var _this2;

    _classCallCheck(this, DatabaseNameCannotBeBlank);

    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(params));
    _this2.name = 'DatabaseNameCannotBeBlank';
    _this2.message = 'Database name cannot be blank.';
    _this2.status = statusCodes['Bad Request'];
    return _this2;
  }

  return DatabaseNameCannotBeBlank;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseNameMustBeString = /*#__PURE__*/function (_Error3) {
  _inherits(DatabaseNameMustBeString, _Error3);

  var _super3 = _createSuper(DatabaseNameMustBeString);

  function DatabaseNameMustBeString() {
    var _this3;

    _classCallCheck(this, DatabaseNameMustBeString);

    for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      params[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(params));
    _this3.name = 'DatabaseNameMustBeString';
    _this3.message = 'Database name must be a string.';
    _this3.status = statusCodes['Bad Request'];
    return _this3;
  }

  return DatabaseNameMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseNameTooLong = /*#__PURE__*/function (_Error4) {
  _inherits(DatabaseNameTooLong, _Error4);

  var _super4 = _createSuper(DatabaseNameTooLong);

  function DatabaseNameTooLong(maxLength) {
    var _this4;

    _classCallCheck(this, DatabaseNameTooLong);

    for (var _len4 = arguments.length, params = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      params[_key4 - 1] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this, maxLength].concat(params));
    _this4.name = 'DatabaseNameTooLong';
    _this4.message = "Database name cannot be more than ".concat(maxLength, " characters.");
    _this4.status = statusCodes['Bad Request'];
    return _this4;
  }

  return DatabaseNameTooLong;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseNameRestricted = /*#__PURE__*/function (_Error5) {
  _inherits(DatabaseNameRestricted, _Error5);

  var _super5 = _createSuper(DatabaseNameRestricted);

  function DatabaseNameRestricted(databaseName) {
    var _this5;

    _classCallCheck(this, DatabaseNameRestricted);

    for (var _len5 = arguments.length, params = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      params[_key5 - 1] = arguments[_key5];
    }

    _this5 = _super5.call.apply(_super5, [this, databaseName].concat(params));
    _this5.name = 'DatabaseNameRestricted';
    _this5.message = "Database name '".concat(databaseName, "' is restricted. It is used internally by userbase-js.");
    _this5.status = statusCodes['Forbidden'];
    return _this5;
  }

  return DatabaseNameRestricted;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseAlreadyOpening = /*#__PURE__*/function (_Error6) {
  _inherits(DatabaseAlreadyOpening, _Error6);

  var _super6 = _createSuper(DatabaseAlreadyOpening);

  function DatabaseAlreadyOpening() {
    var _this6;

    _classCallCheck(this, DatabaseAlreadyOpening);

    for (var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      params[_key6] = arguments[_key6];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(params));
    _this6.name = 'DatabaseAlreadyOpening';
    _this6.message = 'Already attempting to open database.';
    _this6.status = statusCodes['Bad Request'];
    return _this6;
  }

  return DatabaseAlreadyOpening;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ChangeHandlerMissing = /*#__PURE__*/function (_Error7) {
  _inherits(ChangeHandlerMissing, _Error7);

  var _super7 = _createSuper(ChangeHandlerMissing);

  function ChangeHandlerMissing() {
    var _this7;

    _classCallCheck(this, ChangeHandlerMissing);

    for (var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      params[_key7] = arguments[_key7];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(params));
    _this7.name = 'ChangeHandlerMissing';
    _this7.message = 'Change handler missing.';
    _this7.status = statusCodes['Bad Request'];
    return _this7;
  }

  return ChangeHandlerMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ChangeHandlerMustBeFunction = /*#__PURE__*/function (_Error8) {
  _inherits(ChangeHandlerMustBeFunction, _Error8);

  var _super8 = _createSuper(ChangeHandlerMustBeFunction);

  function ChangeHandlerMustBeFunction() {
    var _this8;

    _classCallCheck(this, ChangeHandlerMustBeFunction);

    for (var _len8 = arguments.length, params = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      params[_key8] = arguments[_key8];
    }

    _this8 = _super8.call.apply(_super8, [this].concat(params));
    _this8.name = 'ChangeHandlerMustBeFunction';
    _this8.message = 'Change handler must be a function.';
    _this8.status = statusCodes['Bad Request'];
    return _this8;
  }

  return ChangeHandlerMustBeFunction;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var EncryptionModeNotValid = /*#__PURE__*/function (_Error9) {
  _inherits(EncryptionModeNotValid, _Error9);

  var _super9 = _createSuper(EncryptionModeNotValid);

  function EncryptionModeNotValid(options) {
    var _this9;

    _classCallCheck(this, EncryptionModeNotValid);

    for (var _len9 = arguments.length, params = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
      params[_key9 - 1] = arguments[_key9];
    }

    _this9 = _super9.call.apply(_super9, [this, options].concat(params));
    _this9.name = 'EncryptionModeNotValid';
    _this9.message = "Encryption mode must be one of ".concat(JSON.stringify(Object.keys(options)), ".");
    _this9.status = statusCodes['Bad Request'];
    return _this9;
  }

  return EncryptionModeNotValid;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ServerSideEncryptionNotEnabledInClient = /*#__PURE__*/function (_Error10) {
  _inherits(ServerSideEncryptionNotEnabledInClient, _Error10);

  var _super10 = _createSuper(ServerSideEncryptionNotEnabledInClient);

  function ServerSideEncryptionNotEnabledInClient() {
    var _this10;

    _classCallCheck(this, ServerSideEncryptionNotEnabledInClient);

    for (var _len10 = arguments.length, params = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      params[_key10] = arguments[_key10];
    }

    _this10 = _super10.call.apply(_super10, [this].concat(params));
    _this10.name = 'ServerSideEncryptionNotEnabledInClient';
    _this10.message = 'Server-side encryption must be enabled in the client to use it. To enable it, set allowServerSideEncryption to true in init().';
    _this10.status = statusCodes['Forbidden'];
    return _this10;
  }

  return ServerSideEncryptionNotEnabledInClient;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseNotOpen = /*#__PURE__*/function (_Error11) {
  _inherits(DatabaseNotOpen, _Error11);

  var _super11 = _createSuper(DatabaseNotOpen);

  function DatabaseNotOpen() {
    var _this11;

    _classCallCheck(this, DatabaseNotOpen);

    for (var _len11 = arguments.length, params = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      params[_key11] = arguments[_key11];
    }

    _this11 = _super11.call.apply(_super11, [this].concat(params));
    _this11.name = 'DatabaseNotOpen';
    _this11.message = 'Database is not open.';
    _this11.status = statusCodes['Bad Request'];
    return _this11;
  }

  return DatabaseNotOpen;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseNotFound = /*#__PURE__*/function (_Error12) {
  _inherits(DatabaseNotFound, _Error12);

  var _super12 = _createSuper(DatabaseNotFound);

  function DatabaseNotFound() {
    var _this12;

    _classCallCheck(this, DatabaseNotFound);

    for (var _len12 = arguments.length, params = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      params[_key12] = arguments[_key12];
    }

    _this12 = _super12.call.apply(_super12, [this].concat(params));
    _this12.name = 'DatabaseNotFound';
    _this12.message = 'Database not found. Find available databases using getDatabases().';
    _this12.status = statusCodes['Not Found'];
    return _this12;
  }

  return DatabaseNotFound;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseIsReadOnly = /*#__PURE__*/function (_Error13) {
  _inherits(DatabaseIsReadOnly, _Error13);

  var _super13 = _createSuper(DatabaseIsReadOnly);

  function DatabaseIsReadOnly() {
    var _this13;

    _classCallCheck(this, DatabaseIsReadOnly);

    for (var _len13 = arguments.length, params = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      params[_key13] = arguments[_key13];
    }

    _this13 = _super13.call.apply(_super13, [this].concat(params));
    _this13.name = 'DatabaseIsReadOnly';
    _this13.message = 'Database is read only. Must have permission to write to database.';
    _this13.status = statusCodes['Forbidden'];
    return _this13;
  }

  return DatabaseIsReadOnly;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseIdMustBeString = /*#__PURE__*/function (_Error14) {
  _inherits(DatabaseIdMustBeString, _Error14);

  var _super14 = _createSuper(DatabaseIdMustBeString);

  function DatabaseIdMustBeString() {
    var _this14;

    _classCallCheck(this, DatabaseIdMustBeString);

    for (var _len14 = arguments.length, params = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      params[_key14] = arguments[_key14];
    }

    _this14 = _super14.call.apply(_super14, [this].concat(params));
    _this14.name = 'DatabaseIdMustBeString';
    _this14.message = 'Database id must be a string.';
    _this14.status = statusCodes['Bad Request'];
    return _this14;
  }

  return DatabaseIdMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseIdCannotBeBlank = /*#__PURE__*/function (_Error15) {
  _inherits(DatabaseIdCannotBeBlank, _Error15);

  var _super15 = _createSuper(DatabaseIdCannotBeBlank);

  function DatabaseIdCannotBeBlank() {
    var _this15;

    _classCallCheck(this, DatabaseIdCannotBeBlank);

    for (var _len15 = arguments.length, params = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      params[_key15] = arguments[_key15];
    }

    _this15 = _super15.call.apply(_super15, [this].concat(params));
    _this15.name = 'DatabaseIdCannotBeBlank';
    _this15.message = 'Database id cannot be blank.';
    _this15.status = statusCodes['Bad Request'];
    return _this15;
  }

  return DatabaseIdCannotBeBlank;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseIdNotAllowed = /*#__PURE__*/function (_Error16) {
  _inherits(DatabaseIdNotAllowed, _Error16);

  var _super16 = _createSuper(DatabaseIdNotAllowed);

  function DatabaseIdNotAllowed() {
    var _this16;

    _classCallCheck(this, DatabaseIdNotAllowed);

    for (var _len16 = arguments.length, params = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      params[_key16] = arguments[_key16];
    }

    _this16 = _super16.call.apply(_super16, [this].concat(params));
    _this16.name = 'DatabaseIdNotAllowed';
    _this16.message = 'Database id not allowed. Cannot provide both databaseName and databaseId, can only provide one.';
    _this16.status = statusCodes['Bad Request'];
    return _this16;
  }

  return DatabaseIdNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseIdNotAllowedForOwnDatabase = /*#__PURE__*/function (_Error17) {
  _inherits(DatabaseIdNotAllowedForOwnDatabase, _Error17);

  var _super17 = _createSuper(DatabaseIdNotAllowedForOwnDatabase);

  function DatabaseIdNotAllowedForOwnDatabase() {
    var _this17;

    _classCallCheck(this, DatabaseIdNotAllowedForOwnDatabase);

    for (var _len17 = arguments.length, params = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
      params[_key17] = arguments[_key17];
    }

    _this17 = _super17.call.apply(_super17, [this].concat(params));
    _this17.name = 'DatabaseIdNotAllowedForOwnDatabase';
    _this17.message = "Tried to open the user's own database using its databaseId rather than its databaseName. The databaseId should only be used to open databases shared from other users.";
    _this17.status = statusCodes['Forbidden'];
    return _this17;
  }

  return DatabaseIdNotAllowedForOwnDatabase;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DatabaseIdInvalidLength = /*#__PURE__*/function (_Error18) {
  _inherits(DatabaseIdInvalidLength, _Error18);

  var _super18 = _createSuper(DatabaseIdInvalidLength);

  function DatabaseIdInvalidLength(length) {
    var _this18;

    _classCallCheck(this, DatabaseIdInvalidLength);

    for (var _len18 = arguments.length, params = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
      params[_key18 - 1] = arguments[_key18];
    }

    _this18 = _super18.call.apply(_super18, [this, length].concat(params));
    _this18.name = 'DatabaseIdInvalidLength';
    _this18.message = "Database id invalid length. Must be ".concat(length, " characters.");
    _this18.status = statusCodes['Bad Request'];
    return _this18;
  }

  return DatabaseIdInvalidLength;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ShareTokenInvalid = /*#__PURE__*/function (_Error19) {
  _inherits(ShareTokenInvalid, _Error19);

  var _super19 = _createSuper(ShareTokenInvalid);

  function ShareTokenInvalid() {
    var _this19;

    _classCallCheck(this, ShareTokenInvalid);

    for (var _len19 = arguments.length, params = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
      params[_key19] = arguments[_key19];
    }

    _this19 = _super19.call.apply(_super19, [this].concat(params));
    _this19.name = 'ShareTokenInvalid';
    _this19.message = 'Share token invalid.';
    _this19.status = statusCodes['Bad Request'];
    return _this19;
  }

  return ShareTokenInvalid;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ShareTokenNotFound = /*#__PURE__*/function (_Error20) {
  _inherits(ShareTokenNotFound, _Error20);

  var _super20 = _createSuper(ShareTokenNotFound);

  function ShareTokenNotFound() {
    var _this20;

    _classCallCheck(this, ShareTokenNotFound);

    for (var _len20 = arguments.length, params = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
      params[_key20] = arguments[_key20];
    }

    _this20 = _super20.call.apply(_super20, [this].concat(params));
    _this20.name = 'ShareTokenNotFound';
    _this20.message = 'Share token not found. Perhaps the database owner has generated a new share token.';
    _this20.status = statusCodes['Not Found'];
    return _this20;
  }

  return ShareTokenNotFound;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ShareTokenNotAllowed = /*#__PURE__*/function (_Error21) {
  _inherits(ShareTokenNotAllowed, _Error21);

  var _super21 = _createSuper(ShareTokenNotAllowed);

  function ShareTokenNotAllowed(reason) {
    var _this21;

    _classCallCheck(this, ShareTokenNotAllowed);

    for (var _len21 = arguments.length, params = new Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
      params[_key21 - 1] = arguments[_key21];
    }

    _this21 = _super21.call.apply(_super21, [this, reason].concat(params));
    _this21.name = 'ShareTokenNotAllowed';
    _this21.message = 'Share token not allowed.';
    _this21.status = statusCodes['Bad Request'];
    return _this21;
  }

  return ShareTokenNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ShareTokenNotAllowedForOwnDatabase = /*#__PURE__*/function (_Error22) {
  _inherits(ShareTokenNotAllowedForOwnDatabase, _Error22);

  var _super22 = _createSuper(ShareTokenNotAllowedForOwnDatabase);

  function ShareTokenNotAllowedForOwnDatabase() {
    var _this22;

    _classCallCheck(this, ShareTokenNotAllowedForOwnDatabase);

    for (var _len22 = arguments.length, params = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
      params[_key22] = arguments[_key22];
    }

    _this22 = _super22.call.apply(_super22, [this].concat(params));
    _this22.name = 'ShareTokenNotAllowedForOwnDatabase';
    _this22.message = "Tried to open the user's own database using its shareToken rather than its databaseName. The shareToken should only be used to open databases shared from other users.";
    _this22.status = statusCodes['Forbidden'];
    return _this22;
  }

  return ShareTokenNotAllowedForOwnDatabase;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ReadOnlyMustBeBoolean = /*#__PURE__*/function (_Error23) {
  _inherits(ReadOnlyMustBeBoolean, _Error23);

  var _super23 = _createSuper(ReadOnlyMustBeBoolean);

  function ReadOnlyMustBeBoolean() {
    var _this23;

    _classCallCheck(this, ReadOnlyMustBeBoolean);

    for (var _len23 = arguments.length, params = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
      params[_key23] = arguments[_key23];
    }

    _this23 = _super23.call.apply(_super23, [this].concat(params));
    _this23.name = 'ReadOnlyMustBeBoolean';
    _this23.message = 'Read only value must be a boolean.';
    _this23.status = statusCodes['Bad Request'];
    return _this23;
  }

  return ReadOnlyMustBeBoolean;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ReadOnlyParamNotAllowed = /*#__PURE__*/function (_Error24) {
  _inherits(ReadOnlyParamNotAllowed, _Error24);

  var _super24 = _createSuper(ReadOnlyParamNotAllowed);

  function ReadOnlyParamNotAllowed() {
    var _this24;

    _classCallCheck(this, ReadOnlyParamNotAllowed);

    for (var _len24 = arguments.length, params = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
      params[_key24] = arguments[_key24];
    }

    _this24 = _super24.call.apply(_super24, [this].concat(params));
    _this24.name = 'ReadOnlyParamNotAllowed';
    _this24.message = 'Read only parameter not allowed when revoking access to a database.';
    _this24.status = statusCodes['Bad Request'];
    return _this24;
  }

  return ReadOnlyParamNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ResharingAllowedParamNotAllowed = /*#__PURE__*/function (_Error25) {
  _inherits(ResharingAllowedParamNotAllowed, _Error25);

  var _super25 = _createSuper(ResharingAllowedParamNotAllowed);

  function ResharingAllowedParamNotAllowed(reason) {
    var _this25;

    _classCallCheck(this, ResharingAllowedParamNotAllowed);

    for (var _len25 = arguments.length, params = new Array(_len25 > 1 ? _len25 - 1 : 0), _key25 = 1; _key25 < _len25; _key25++) {
      params[_key25 - 1] = arguments[_key25];
    }

    _this25 = _super25.call.apply(_super25, [this, reason].concat(params));
    _this25.name = 'ResharingAllowedParamNotAllowed';
    _this25.message = "Resharing allowed parameter not allowed ".concat(reason, ".");
    _this25.status = statusCodes['Bad Request'];
    return _this25;
  }

  return ResharingAllowedParamNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ResharingAllowedMustBeBoolean = /*#__PURE__*/function (_Error26) {
  _inherits(ResharingAllowedMustBeBoolean, _Error26);

  var _super26 = _createSuper(ResharingAllowedMustBeBoolean);

  function ResharingAllowedMustBeBoolean() {
    var _this26;

    _classCallCheck(this, ResharingAllowedMustBeBoolean);

    for (var _len26 = arguments.length, params = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
      params[_key26] = arguments[_key26];
    }

    _this26 = _super26.call.apply(_super26, [this].concat(params));
    _this26.name = 'ResharingAllowedMustBeBoolean';
    _this26.message = 'Resharing allowed value must be a boolean.';
    _this26.status = statusCodes['Bad Request'];
    return _this26;
  }

  return ResharingAllowedMustBeBoolean;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ResharingNotAllowed = /*#__PURE__*/function (_Error27) {
  _inherits(ResharingNotAllowed, _Error27);

  var _super27 = _createSuper(ResharingNotAllowed);

  function ResharingNotAllowed(reason) {
    var _this27;

    _classCallCheck(this, ResharingNotAllowed);

    for (var _len27 = arguments.length, params = new Array(_len27 > 1 ? _len27 - 1 : 0), _key27 = 1; _key27 < _len27; _key27++) {
      params[_key27 - 1] = arguments[_key27];
    }

    _this27 = _super27.call.apply(_super27, [this, reason].concat(params));
    _this27.name = 'ResharingNotAllowed';
    _this27.message = "Resharing not allowed. ".concat(reason, ".");
    _this27.status = statusCodes['Forbidden'];
    return _this27;
  }

  return ResharingNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ResharingWithWriteAccessNotAllowed = /*#__PURE__*/function (_Error28) {
  _inherits(ResharingWithWriteAccessNotAllowed, _Error28);

  var _super28 = _createSuper(ResharingWithWriteAccessNotAllowed);

  function ResharingWithWriteAccessNotAllowed() {
    var _this28;

    _classCallCheck(this, ResharingWithWriteAccessNotAllowed);

    for (var _len28 = arguments.length, params = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
      params[_key28] = arguments[_key28];
    }

    _this28 = _super28.call.apply(_super28, [this].concat(params));
    _this28.name = 'ResharingWithWriteAccessNotAllowed';
    _this28.message = 'Resharing with write access not allowed. Must have permission to write to the database to reshare the database with write access another user.';
    _this28.status = statusCodes['Forbidden'];
    return _this28;
  }

  return ResharingWithWriteAccessNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SharingWithSelfNotAllowed = /*#__PURE__*/function (_Error29) {
  _inherits(SharingWithSelfNotAllowed, _Error29);

  var _super29 = _createSuper(SharingWithSelfNotAllowed);

  function SharingWithSelfNotAllowed() {
    var _this29;

    _classCallCheck(this, SharingWithSelfNotAllowed);

    for (var _len29 = arguments.length, params = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
      params[_key29] = arguments[_key29];
    }

    _this29 = _super29.call.apply(_super29, [this].concat(params));
    _this29.name = 'SharingWithSelfNotAllowed';
    _this29.message = 'Sharing database with self is not allowed. Must share database with another user.';
    _this29.status = statusCodes['Bad Request'];
    return _this29;
  }

  return SharingWithSelfNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ModifyingOwnPermissionsNotAllowed = /*#__PURE__*/function (_Error30) {
  _inherits(ModifyingOwnPermissionsNotAllowed, _Error30);

  var _super30 = _createSuper(ModifyingOwnPermissionsNotAllowed);

  function ModifyingOwnPermissionsNotAllowed() {
    var _this30;

    _classCallCheck(this, ModifyingOwnPermissionsNotAllowed);

    for (var _len30 = arguments.length, params = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
      params[_key30] = arguments[_key30];
    }

    _this30 = _super30.call.apply(_super30, [this].concat(params));
    _this30.name = 'ModifyingOwnPermissionsNotAllowed';
    _this30.message = "Modifying own database permissions not allowed. Must modify another user's permissions.";
    _this30.status = statusCodes['Bad Request'];
    return _this30;
  }

  return ModifyingOwnPermissionsNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ModifyingOwnerPermissionsNotAllowed = /*#__PURE__*/function (_Error31) {
  _inherits(ModifyingOwnerPermissionsNotAllowed, _Error31);

  var _super31 = _createSuper(ModifyingOwnerPermissionsNotAllowed);

  function ModifyingOwnerPermissionsNotAllowed() {
    var _this31;

    _classCallCheck(this, ModifyingOwnerPermissionsNotAllowed);

    for (var _len31 = arguments.length, params = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
      params[_key31] = arguments[_key31];
    }

    _this31 = _super31.call.apply(_super31, [this].concat(params));
    _this31.name = 'ModifyingOwnerPermissionsNotAllowed';
    _this31.message = "Modifying the owner of a database's permissions is not allowed.";
    _this31.status = statusCodes['Forbidden'];
    return _this31;
  }

  return ModifyingOwnerPermissionsNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ModifyingPermissionsNotAllowed = /*#__PURE__*/function (_Error32) {
  _inherits(ModifyingPermissionsNotAllowed, _Error32);

  var _super32 = _createSuper(ModifyingPermissionsNotAllowed);

  function ModifyingPermissionsNotAllowed() {
    var _this32;

    _classCallCheck(this, ModifyingPermissionsNotAllowed);

    for (var _len32 = arguments.length, params = new Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
      params[_key32] = arguments[_key32];
    }

    _this32 = _super32.call.apply(_super32, [this].concat(params));
    _this32.name = 'ModifyingPermissionsNotAllowed';
    _this32.message = "Modifying another user's permissions is not allowed. Must have permission to reshare the database with another user.";
    _this32.status = statusCodes['Forbidden'];
    return _this32;
  }

  return ModifyingPermissionsNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var GrantingWriteAccessNotAllowed = /*#__PURE__*/function (_Error33) {
  _inherits(GrantingWriteAccessNotAllowed, _Error33);

  var _super33 = _createSuper(GrantingWriteAccessNotAllowed);

  function GrantingWriteAccessNotAllowed() {
    var _this33;

    _classCallCheck(this, GrantingWriteAccessNotAllowed);

    for (var _len33 = arguments.length, params = new Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {
      params[_key33] = arguments[_key33];
    }

    _this33 = _super33.call.apply(_super33, [this].concat(params));
    _this33.name = 'GrantingWriteAccessNotAllowed';
    _this33.message = 'Granting write access not allowed. Must have permission to write to the database to grant write access to another user.';
    _this33.status = statusCodes['Forbidden'];
    return _this33;
  }

  return GrantingWriteAccessNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RequireVerifiedMustBeBoolean = /*#__PURE__*/function (_Error34) {
  _inherits(RequireVerifiedMustBeBoolean, _Error34);

  var _super34 = _createSuper(RequireVerifiedMustBeBoolean);

  function RequireVerifiedMustBeBoolean() {
    var _this34;

    _classCallCheck(this, RequireVerifiedMustBeBoolean);

    for (var _len34 = arguments.length, params = new Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {
      params[_key34] = arguments[_key34];
    }

    _this34 = _super34.call.apply(_super34, [this].concat(params));
    _this34.name = 'RequireVerifiedMustBeBoolean';
    _this34.message = 'Require verified value must be a boolean.';
    _this34.status = statusCodes['Bad Request'];
    return _this34;
  }

  return RequireVerifiedMustBeBoolean;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RequireVerifiedParamNotNecessary = /*#__PURE__*/function (_Error35) {
  _inherits(RequireVerifiedParamNotNecessary, _Error35);

  var _super35 = _createSuper(RequireVerifiedParamNotNecessary);

  function RequireVerifiedParamNotNecessary() {
    var _this35;

    _classCallCheck(this, RequireVerifiedParamNotNecessary);

    for (var _len35 = arguments.length, params = new Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {
      params[_key35] = arguments[_key35];
    }

    _this35 = _super35.call.apply(_super35, [this].concat(params));
    _this35.name = 'RequireVerifiedParamNotNecessary';
    _this35.message = 'Require verified parameter not necessary when sharing database without a username.';
    _this35.status = statusCodes['Bad Request'];
    return _this35;
  }

  return RequireVerifiedParamNotNecessary;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RevokeMustBeBoolean = /*#__PURE__*/function (_Error36) {
  _inherits(RevokeMustBeBoolean, _Error36);

  var _super36 = _createSuper(RevokeMustBeBoolean);

  function RevokeMustBeBoolean() {
    var _this36;

    _classCallCheck(this, RevokeMustBeBoolean);

    for (var _len36 = arguments.length, params = new Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {
      params[_key36] = arguments[_key36];
    }

    _this36 = _super36.call.apply(_super36, [this].concat(params));
    _this36.name = 'RevokeMustBeBoolean';
    _this36.message = 'Revoke value must be a boolean.';
    _this36.status = statusCodes['Bad Request'];
    return _this36;
  }

  return RevokeMustBeBoolean;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ItemMissing = /*#__PURE__*/function (_Error37) {
  _inherits(ItemMissing, _Error37);

  var _super37 = _createSuper(ItemMissing);

  function ItemMissing() {
    var _this37;

    _classCallCheck(this, ItemMissing);

    for (var _len37 = arguments.length, params = new Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {
      params[_key37] = arguments[_key37];
    }

    _this37 = _super37.call.apply(_super37, [this].concat(params));
    _this37.name = 'ItemMissing';
    _this37.message = 'Item missing.';
    _this37.status = statusCodes['Bad Request'];
    return _this37;
  }

  return ItemMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ItemInvalid = /*#__PURE__*/function (_Error38) {
  _inherits(ItemInvalid, _Error38);

  var _super38 = _createSuper(ItemInvalid);

  function ItemInvalid() {
    var _this38;

    _classCallCheck(this, ItemInvalid);

    for (var _len38 = arguments.length, params = new Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {
      params[_key38] = arguments[_key38];
    }

    _this38 = _super38.call.apply(_super38, [this].concat(params));
    _this38.name = 'ItemInvalid';
    _this38.message = 'Item must be serializable to JSON.';
    _this38.status = statusCodes['Bad Request'];
    return _this38;
  }

  return ItemInvalid;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ItemTooLarge = /*#__PURE__*/function (_Error39) {
  _inherits(ItemTooLarge, _Error39);

  var _super39 = _createSuper(ItemTooLarge);

  function ItemTooLarge(maxKb) {
    var _this39;

    _classCallCheck(this, ItemTooLarge);

    for (var _len39 = arguments.length, params = new Array(_len39 > 1 ? _len39 - 1 : 0), _key39 = 1; _key39 < _len39; _key39++) {
      params[_key39 - 1] = arguments[_key39];
    }

    _this39 = _super39.call.apply(_super39, [this, maxKb].concat(params));
    _this39.name = 'ItemTooLarge';
    _this39.message = "Item must be less than ".concat(maxKb, " KB.");
    _this39.status = statusCodes['Bad Request'];
    return _this39;
  }

  return ItemTooLarge;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ItemIdMustBeString = /*#__PURE__*/function (_Error40) {
  _inherits(ItemIdMustBeString, _Error40);

  var _super40 = _createSuper(ItemIdMustBeString);

  function ItemIdMustBeString() {
    var _this40;

    _classCallCheck(this, ItemIdMustBeString);

    for (var _len40 = arguments.length, params = new Array(_len40), _key40 = 0; _key40 < _len40; _key40++) {
      params[_key40] = arguments[_key40];
    }

    _this40 = _super40.call.apply(_super40, [this].concat(params));
    _this40.name = 'ItemIdMustBeString';
    _this40.message = 'Item id must be a string.';
    _this40.status = statusCodes['Bad Request'];
    return _this40;
  }

  return ItemIdMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ItemIdTooLong = /*#__PURE__*/function (_Error41) {
  _inherits(ItemIdTooLong, _Error41);

  var _super41 = _createSuper(ItemIdTooLong);

  function ItemIdTooLong(maxLength) {
    var _this41;

    _classCallCheck(this, ItemIdTooLong);

    for (var _len41 = arguments.length, params = new Array(_len41 > 1 ? _len41 - 1 : 0), _key41 = 1; _key41 < _len41; _key41++) {
      params[_key41 - 1] = arguments[_key41];
    }

    _this41 = _super41.call.apply(_super41, [this, maxLength].concat(params));
    _this41.name = 'ItemIdTooLong';
    _this41.message = "Item id cannot be more than ".concat(maxLength, " characters.");
    _this41.status = statusCodes['Bad Request'];
    return _this41;
  }

  return ItemIdTooLong;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ItemIdMissing = /*#__PURE__*/function (_Error42) {
  _inherits(ItemIdMissing, _Error42);

  var _super42 = _createSuper(ItemIdMissing);

  function ItemIdMissing() {
    var _this42;

    _classCallCheck(this, ItemIdMissing);

    for (var _len42 = arguments.length, params = new Array(_len42), _key42 = 0; _key42 < _len42; _key42++) {
      params[_key42] = arguments[_key42];
    }

    _this42 = _super42.call.apply(_super42, [this].concat(params));
    _this42.name = 'ItemIdMissing';
    _this42.message = 'Item id missing.';
    _this42.status = statusCodes['Bad Request'];
    return _this42;
  }

  return ItemIdMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ItemIdCannotBeBlank = /*#__PURE__*/function (_Error43) {
  _inherits(ItemIdCannotBeBlank, _Error43);

  var _super43 = _createSuper(ItemIdCannotBeBlank);

  function ItemIdCannotBeBlank() {
    var _this43;

    _classCallCheck(this, ItemIdCannotBeBlank);

    for (var _len43 = arguments.length, params = new Array(_len43), _key43 = 0; _key43 < _len43; _key43++) {
      params[_key43] = arguments[_key43];
    }

    _this43 = _super43.call.apply(_super43, [this].concat(params));
    _this43.name = 'ItemIdCannotBeBlank';
    _this43.message = 'Item id cannot be blank.';
    _this43.status = statusCodes['Bad Request'];
    return _this43;
  }

  return ItemIdCannotBeBlank;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ItemAlreadyExists = /*#__PURE__*/function (_Error44) {
  _inherits(ItemAlreadyExists, _Error44);

  var _super44 = _createSuper(ItemAlreadyExists);

  function ItemAlreadyExists() {
    var _this44;

    _classCallCheck(this, ItemAlreadyExists);

    for (var _len44 = arguments.length, params = new Array(_len44), _key44 = 0; _key44 < _len44; _key44++) {
      params[_key44] = arguments[_key44];
    }

    _this44 = _super44.call.apply(_super44, [this].concat(params));
    _this44.name = 'ItemAlreadyExists';
    _this44.message = 'Item with the same id already exists.';
    _this44.status = statusCodes['Conflict'];
    return _this44;
  }

  return ItemAlreadyExists;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ItemDoesNotExist = /*#__PURE__*/function (_Error45) {
  _inherits(ItemDoesNotExist, _Error45);

  var _super45 = _createSuper(ItemDoesNotExist);

  function ItemDoesNotExist() {
    var _this45;

    _classCallCheck(this, ItemDoesNotExist);

    for (var _len45 = arguments.length, params = new Array(_len45), _key45 = 0; _key45 < _len45; _key45++) {
      params[_key45] = arguments[_key45];
    }

    _this45 = _super45.call.apply(_super45, [this].concat(params));
    _this45.name = 'ItemDoesNotExist';
    _this45.message = 'Item with the provided id does not exist.';
    _this45.status = statusCodes['Not Found'];
    return _this45;
  }

  return ItemDoesNotExist;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ItemUpdateConflict = /*#__PURE__*/function (_Error46) {
  _inherits(ItemUpdateConflict, _Error46);

  var _super46 = _createSuper(ItemUpdateConflict);

  function ItemUpdateConflict() {
    var _this46;

    _classCallCheck(this, ItemUpdateConflict);

    for (var _len46 = arguments.length, params = new Array(_len46), _key46 = 0; _key46 < _len46; _key46++) {
      params[_key46] = arguments[_key46];
    }

    _this46 = _super46.call.apply(_super46, [this].concat(params));
    _this46.name = 'ItemUpdateConflict';
    _this46.message = 'Item update conflict.';
    _this46.status = statusCodes['Conflict'];
    return _this46;
  }

  return ItemUpdateConflict;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var FileMissing = /*#__PURE__*/function (_Error47) {
  _inherits(FileMissing, _Error47);

  var _super47 = _createSuper(FileMissing);

  function FileMissing() {
    var _this47;

    _classCallCheck(this, FileMissing);

    for (var _len47 = arguments.length, params = new Array(_len47), _key47 = 0; _key47 < _len47; _key47++) {
      params[_key47] = arguments[_key47];
    }

    _this47 = _super47.call.apply(_super47, [this].concat(params));
    _this47.name = 'FileMissing';
    _this47.message = 'File missing.';
    _this47.status = statusCodes['Bad Request'];
    return _this47;
  }

  return FileMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var FileMustBeFile = /*#__PURE__*/function (_Error48) {
  _inherits(FileMustBeFile, _Error48);

  var _super48 = _createSuper(FileMustBeFile);

  function FileMustBeFile() {
    var _this48;

    _classCallCheck(this, FileMustBeFile);

    for (var _len48 = arguments.length, params = new Array(_len48), _key48 = 0; _key48 < _len48; _key48++) {
      params[_key48] = arguments[_key48];
    }

    _this48 = _super48.call.apply(_super48, [this].concat(params));
    _this48.name = 'FileMustBeFile';
    _this48.message = 'File must be a file.';
    _this48.status = statusCodes['Bad Request'];
    return _this48;
  }

  return FileMustBeFile;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var FileCannotBeEmpty = /*#__PURE__*/function (_Error49) {
  _inherits(FileCannotBeEmpty, _Error49);

  var _super49 = _createSuper(FileCannotBeEmpty);

  function FileCannotBeEmpty() {
    var _this49;

    _classCallCheck(this, FileCannotBeEmpty);

    for (var _len49 = arguments.length, params = new Array(_len49), _key49 = 0; _key49 < _len49; _key49++) {
      params[_key49] = arguments[_key49];
    }

    _this49 = _super49.call.apply(_super49, [this].concat(params));
    _this49.name = 'FileCannotBeEmpty';
    _this49.message = 'File cannot be empty.';
    _this49.status = statusCodes['Bad Request'];
    return _this49;
  }

  return FileCannotBeEmpty;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var FileUploadConflict = /*#__PURE__*/function (_Error50) {
  _inherits(FileUploadConflict, _Error50);

  var _super50 = _createSuper(FileUploadConflict);

  function FileUploadConflict() {
    var _this50;

    _classCallCheck(this, FileUploadConflict);

    for (var _len50 = arguments.length, params = new Array(_len50), _key50 = 0; _key50 < _len50; _key50++) {
      params[_key50] = arguments[_key50];
    }

    _this50 = _super50.call.apply(_super50, [this].concat(params));
    _this50.name = 'FileUploadConflict';
    _this50.message = 'File upload conflict.';
    _this50.status = statusCodes['Conflict'];
    return _this50;
  }

  return FileUploadConflict;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var FileNotFound = /*#__PURE__*/function (_Error51) {
  _inherits(FileNotFound, _Error51);

  var _super51 = _createSuper(FileNotFound);

  function FileNotFound() {
    var _this51;

    _classCallCheck(this, FileNotFound);

    for (var _len51 = arguments.length, params = new Array(_len51), _key51 = 0; _key51 < _len51; _key51++) {
      params[_key51] = arguments[_key51];
    }

    _this51 = _super51.call.apply(_super51, [this].concat(params));
    _this51.name = 'FileNotFound';
    _this51.message = 'File not found.';
    _this51.status = statusCodes['Not Found'];
    return _this51;
  }

  return FileNotFound;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var FileIdMissing = /*#__PURE__*/function (_Error52) {
  _inherits(FileIdMissing, _Error52);

  var _super52 = _createSuper(FileIdMissing);

  function FileIdMissing() {
    var _this52;

    _classCallCheck(this, FileIdMissing);

    for (var _len52 = arguments.length, params = new Array(_len52), _key52 = 0; _key52 < _len52; _key52++) {
      params[_key52] = arguments[_key52];
    }

    _this52 = _super52.call.apply(_super52, [this].concat(params));
    _this52.name = 'FileIdMissing';
    _this52.message = 'File id missing.';
    _this52.status = statusCodes['Bad Request'];
    return _this52;
  }

  return FileIdMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var FileIdMustBeString = /*#__PURE__*/function (_Error53) {
  _inherits(FileIdMustBeString, _Error53);

  var _super53 = _createSuper(FileIdMustBeString);

  function FileIdMustBeString() {
    var _this53;

    _classCallCheck(this, FileIdMustBeString);

    for (var _len53 = arguments.length, params = new Array(_len53), _key53 = 0; _key53 < _len53; _key53++) {
      params[_key53] = arguments[_key53];
    }

    _this53 = _super53.call.apply(_super53, [this].concat(params));
    _this53.name = 'FileIdMustBeString';
    _this53.message = 'File id must be a string.';
    _this53.status = statusCodes['Bad Request'];
    return _this53;
  }

  return FileIdMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var FileIdCannotBeBlank = /*#__PURE__*/function (_Error54) {
  _inherits(FileIdCannotBeBlank, _Error54);

  var _super54 = _createSuper(FileIdCannotBeBlank);

  function FileIdCannotBeBlank() {
    var _this54;

    _classCallCheck(this, FileIdCannotBeBlank);

    for (var _len54 = arguments.length, params = new Array(_len54), _key54 = 0; _key54 < _len54; _key54++) {
      params[_key54] = arguments[_key54];
    }

    _this54 = _super54.call.apply(_super54, [this].concat(params));
    _this54.name = 'FileIdCannotBeBlank';
    _this54.message = 'File id cannot be blank.';
    _this54.status = statusCodes['Bad Request'];
    return _this54;
  }

  return FileIdCannotBeBlank;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var FileIdTooLong = /*#__PURE__*/function (_Error55) {
  _inherits(FileIdTooLong, _Error55);

  var _super55 = _createSuper(FileIdTooLong);

  function FileIdTooLong(maxLength) {
    var _this55;

    _classCallCheck(this, FileIdTooLong);

    for (var _len55 = arguments.length, params = new Array(_len55 > 1 ? _len55 - 1 : 0), _key55 = 1; _key55 < _len55; _key55++) {
      params[_key55 - 1] = arguments[_key55];
    }

    _this55 = _super55.call.apply(_super55, [this, maxLength].concat(params));
    _this55.name = 'FileIdTooLong';
    _this55.message = "File id cannot be more than ".concat(maxLength, " characters.");
    _this55.status = statusCodes['Bad Request'];
    return _this55;
  }

  return FileIdTooLong;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RangeMustBeObject = /*#__PURE__*/function (_Error56) {
  _inherits(RangeMustBeObject, _Error56);

  var _super56 = _createSuper(RangeMustBeObject);

  function RangeMustBeObject() {
    var _this56;

    _classCallCheck(this, RangeMustBeObject);

    for (var _len56 = arguments.length, params = new Array(_len56), _key56 = 0; _key56 < _len56; _key56++) {
      params[_key56] = arguments[_key56];
    }

    _this56 = _super56.call.apply(_super56, [this].concat(params));
    _this56.name = 'RangeMustBeObject';
    _this56.message = 'Range param provided must be object.';
    _this56.status = statusCodes['Bad Request'];
    return _this56;
  }

  return RangeMustBeObject;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RangeMissingStart = /*#__PURE__*/function (_Error57) {
  _inherits(RangeMissingStart, _Error57);

  var _super57 = _createSuper(RangeMissingStart);

  function RangeMissingStart() {
    var _this57;

    _classCallCheck(this, RangeMissingStart);

    for (var _len57 = arguments.length, params = new Array(_len57), _key57 = 0; _key57 < _len57; _key57++) {
      params[_key57] = arguments[_key57];
    }

    _this57 = _super57.call.apply(_super57, [this].concat(params));
    _this57.name = 'RangeMissingStart';
    _this57.message = 'Range param missing start.';
    _this57.status = statusCodes['Bad Request'];
    return _this57;
  }

  return RangeMissingStart;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RangeMissingEnd = /*#__PURE__*/function (_Error58) {
  _inherits(RangeMissingEnd, _Error58);

  var _super58 = _createSuper(RangeMissingEnd);

  function RangeMissingEnd() {
    var _this58;

    _classCallCheck(this, RangeMissingEnd);

    for (var _len58 = arguments.length, params = new Array(_len58), _key58 = 0; _key58 < _len58; _key58++) {
      params[_key58] = arguments[_key58];
    }

    _this58 = _super58.call.apply(_super58, [this].concat(params));
    _this58.name = 'RangeMissingEnd';
    _this58.message = 'Range param missing end.';
    _this58.status = statusCodes['Bad Request'];
    return _this58;
  }

  return RangeMissingEnd;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RangeStartMustBeNumber = /*#__PURE__*/function (_Error59) {
  _inherits(RangeStartMustBeNumber, _Error59);

  var _super59 = _createSuper(RangeStartMustBeNumber);

  function RangeStartMustBeNumber() {
    var _this59;

    _classCallCheck(this, RangeStartMustBeNumber);

    for (var _len59 = arguments.length, params = new Array(_len59), _key59 = 0; _key59 < _len59; _key59++) {
      params[_key59] = arguments[_key59];
    }

    _this59 = _super59.call.apply(_super59, [this].concat(params));
    _this59.name = 'RangeStartMustBeNumber';
    _this59.message = 'Range start provided must be a number.';
    _this59.status = statusCodes['Bad Request'];
    return _this59;
  }

  return RangeStartMustBeNumber;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RangeEndMustBeNumber = /*#__PURE__*/function (_Error60) {
  _inherits(RangeEndMustBeNumber, _Error60);

  var _super60 = _createSuper(RangeEndMustBeNumber);

  function RangeEndMustBeNumber() {
    var _this60;

    _classCallCheck(this, RangeEndMustBeNumber);

    for (var _len60 = arguments.length, params = new Array(_len60), _key60 = 0; _key60 < _len60; _key60++) {
      params[_key60] = arguments[_key60];
    }

    _this60 = _super60.call.apply(_super60, [this].concat(params));
    _this60.name = 'RangeEndMustBeNumber';
    _this60.message = 'Range end provided must be a number.';
    _this60.status = statusCodes['Bad Request'];
    return _this60;
  }

  return RangeEndMustBeNumber;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RangeStartMustBeGreaterThanZero = /*#__PURE__*/function (_Error61) {
  _inherits(RangeStartMustBeGreaterThanZero, _Error61);

  var _super61 = _createSuper(RangeStartMustBeGreaterThanZero);

  function RangeStartMustBeGreaterThanZero() {
    var _this61;

    _classCallCheck(this, RangeStartMustBeGreaterThanZero);

    for (var _len61 = arguments.length, params = new Array(_len61), _key61 = 0; _key61 < _len61; _key61++) {
      params[_key61] = arguments[_key61];
    }

    _this61 = _super61.call.apply(_super61, [this].concat(params));
    _this61.name = 'RangeStartMustBeGreaterThanZero';
    _this61.message = 'Range start provided must be greater than 0.';
    _this61.status = statusCodes['Bad Request'];
    return _this61;
  }

  return RangeStartMustBeGreaterThanZero;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RangeEndMustBeGreaterThanRangeStart = /*#__PURE__*/function (_Error62) {
  _inherits(RangeEndMustBeGreaterThanRangeStart, _Error62);

  var _super62 = _createSuper(RangeEndMustBeGreaterThanRangeStart);

  function RangeEndMustBeGreaterThanRangeStart() {
    var _this62;

    _classCallCheck(this, RangeEndMustBeGreaterThanRangeStart);

    for (var _len62 = arguments.length, params = new Array(_len62), _key62 = 0; _key62 < _len62; _key62++) {
      params[_key62] = arguments[_key62];
    }

    _this62 = _super62.call.apply(_super62, [this].concat(params));
    _this62.name = 'RangeEndMustBeGreaterThanRangeStart';
    _this62.message = 'Range end provided must be greater than range start.';
    _this62.status = statusCodes['Bad Request'];
    return _this62;
  }

  return RangeEndMustBeGreaterThanRangeStart;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RangeEndMustBeLessThanFileSize = /*#__PURE__*/function (_Error63) {
  _inherits(RangeEndMustBeLessThanFileSize, _Error63);

  var _super63 = _createSuper(RangeEndMustBeLessThanFileSize);

  function RangeEndMustBeLessThanFileSize() {
    var _this63;

    _classCallCheck(this, RangeEndMustBeLessThanFileSize);

    for (var _len63 = arguments.length, params = new Array(_len63), _key63 = 0; _key63 < _len63; _key63++) {
      params[_key63] = arguments[_key63];
    }

    _this63 = _super63.call.apply(_super63, [this].concat(params));
    _this63.name = 'RangeEndMustBeLessThanFileSize';
    _this63.message = 'Range end provided must be less than file size.';
    _this63.status = statusCodes['Bad Request'];
    return _this63;
  }

  return RangeEndMustBeLessThanFileSize;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var OperationsMissing = /*#__PURE__*/function (_Error64) {
  _inherits(OperationsMissing, _Error64);

  var _super64 = _createSuper(OperationsMissing);

  function OperationsMissing() {
    var _this64;

    _classCallCheck(this, OperationsMissing);

    for (var _len64 = arguments.length, params = new Array(_len64), _key64 = 0; _key64 < _len64; _key64++) {
      params[_key64] = arguments[_key64];
    }

    _this64 = _super64.call.apply(_super64, [this].concat(params));
    _this64.name = 'OperationsMissing';
    _this64.message = 'Operations missing.';
    _this64.status = statusCodes['Bad Request'];
    return _this64;
  }

  return OperationsMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var OperationsMustBeArray = /*#__PURE__*/function (_Error65) {
  _inherits(OperationsMustBeArray, _Error65);

  var _super65 = _createSuper(OperationsMustBeArray);

  function OperationsMustBeArray() {
    var _this65;

    _classCallCheck(this, OperationsMustBeArray);

    for (var _len65 = arguments.length, params = new Array(_len65), _key65 = 0; _key65 < _len65; _key65++) {
      params[_key65] = arguments[_key65];
    }

    _this65 = _super65.call.apply(_super65, [this].concat(params));
    _this65.name = 'OperationsMustBeArray';
    _this65.message = 'Operations provided must be an array.';
    _this65.status = statusCodes['Bad Request'];
    return _this65;
  }

  return OperationsMustBeArray;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var CommandNotRecognized = /*#__PURE__*/function (_Error66) {
  _inherits(CommandNotRecognized, _Error66);

  var _super66 = _createSuper(CommandNotRecognized);

  function CommandNotRecognized(command) {
    var _this66;

    _classCallCheck(this, CommandNotRecognized);

    for (var _len66 = arguments.length, params = new Array(_len66 > 1 ? _len66 - 1 : 0), _key66 = 1; _key66 < _len66; _key66++) {
      params[_key66 - 1] = arguments[_key66];
    }

    _this66 = _super66.call.apply(_super66, [this, command].concat(params));
    _this66.name = 'CommandNotRecognized';
    _this66.message = "Command '".concat(command, "' not recognized.");
    _this66.status = statusCodes['Bad Request'];
    return _this66;
  }

  return CommandNotRecognized;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var OperationsConflict = /*#__PURE__*/function (_Error67) {
  _inherits(OperationsConflict, _Error67);

  var _super67 = _createSuper(OperationsConflict);

  function OperationsConflict() {
    var _this67;

    _classCallCheck(this, OperationsConflict);

    for (var _len67 = arguments.length, params = new Array(_len67), _key67 = 0; _key67 < _len67; _key67++) {
      params[_key67] = arguments[_key67];
    }

    _this67 = _super67.call.apply(_super67, [this].concat(params));
    _this67.name = 'OperationsConflict';
    _this67.message = 'Operations conflict. Only allowed 1 operation per item.';
    _this67.status = statusCodes['Conflict'];
    return _this67;
  }

  return OperationsConflict;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var OperationsExceedLimit = /*#__PURE__*/function (_Error68) {
  _inherits(OperationsExceedLimit, _Error68);

  var _super68 = _createSuper(OperationsExceedLimit);

  function OperationsExceedLimit(limit) {
    var _this68;

    _classCallCheck(this, OperationsExceedLimit);

    for (var _len68 = arguments.length, params = new Array(_len68 > 1 ? _len68 - 1 : 0), _key68 = 1; _key68 < _len68; _key68++) {
      params[_key68 - 1] = arguments[_key68];
    }

    _this68 = _super68.call.apply(_super68, [this, limit].concat(params));
    _this68.name = 'OperationsExceedLimit';
    _this68.message = "Operations exceed limit. Only allowed ".concat(limit, " operations.");
    _this68.status = statusCodes['Bad Request'];
    return _this68;
  }

  return OperationsExceedLimit;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UserNotVerified = /*#__PURE__*/function (_Error69) {
  _inherits(UserNotVerified, _Error69);

  var _super69 = _createSuper(UserNotVerified);

  function UserNotVerified() {
    var _this69;

    _classCallCheck(this, UserNotVerified);

    for (var _len69 = arguments.length, params = new Array(_len69), _key69 = 0; _key69 < _len69; _key69++) {
      params[_key69] = arguments[_key69];
    }

    _this69 = _super69.call.apply(_super69, [this].concat(params));
    _this69.name = 'UserNotVerified';
    _this69.message = 'User not verified. Either verify user before sharing database, or set requireVerified to false.';
    _this69.status = statusCodes['Forbidden'];
    return _this69;
  }

  return UserNotVerified;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UserMustBeReverified = /*#__PURE__*/function (_Error70) {
  _inherits(UserMustBeReverified, _Error70);

  var _super70 = _createSuper(UserMustBeReverified);

  function UserMustBeReverified() {
    var _this70;

    _classCallCheck(this, UserMustBeReverified);

    for (var _len70 = arguments.length, params = new Array(_len70), _key70 = 0; _key70 < _len70; _key70++) {
      params[_key70] = arguments[_key70];
    }

    _this70 = _super70.call.apply(_super70, [this].concat(params));
    _this70.name = 'UserMustBeReverified';
    _this70.message = 'User must be reverified.';
    _this70.status = statusCodes['Forbidden'];
    return _this70;
  }

  return UserMustBeReverified;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UserUnableToReceiveDatabase = /*#__PURE__*/function (_Error71) {
  _inherits(UserUnableToReceiveDatabase, _Error71);

  var _super71 = _createSuper(UserUnableToReceiveDatabase);

  function UserUnableToReceiveDatabase() {
    var _this71;

    _classCallCheck(this, UserUnableToReceiveDatabase);

    for (var _len71 = arguments.length, params = new Array(_len71), _key71 = 0; _key71 < _len71; _key71++) {
      params[_key71] = arguments[_key71];
    }

    _this71 = _super71.call.apply(_super71, [this].concat(params));
    _this71.name = 'UserUnableToReceiveDatabase';
    _this71.message = 'User unable to receive database. User must sign in with an updated userbase-js client to be able to receive database.';
    _this71.status = statusCodes['Forbidden'];
    return _this71;
  }

  return UserUnableToReceiveDatabase;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var VerificationMessageMissing = /*#__PURE__*/function (_Error72) {
  _inherits(VerificationMessageMissing, _Error72);

  var _super72 = _createSuper(VerificationMessageMissing);

  function VerificationMessageMissing() {
    var _this72;

    _classCallCheck(this, VerificationMessageMissing);

    for (var _len72 = arguments.length, params = new Array(_len72), _key72 = 0; _key72 < _len72; _key72++) {
      params[_key72] = arguments[_key72];
    }

    _this72 = _super72.call.apply(_super72, [this].concat(params));
    _this72.name = 'VerificationMessageMissing';
    _this72.message = 'Verification message missing.';
    _this72.status = statusCodes['Bad Request'];
    return _this72;
  }

  return VerificationMessageMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var VerificationMessageCannotBeBlank = /*#__PURE__*/function (_Error73) {
  _inherits(VerificationMessageCannotBeBlank, _Error73);

  var _super73 = _createSuper(VerificationMessageCannotBeBlank);

  function VerificationMessageCannotBeBlank() {
    var _this73;

    _classCallCheck(this, VerificationMessageCannotBeBlank);

    for (var _len73 = arguments.length, params = new Array(_len73), _key73 = 0; _key73 < _len73; _key73++) {
      params[_key73] = arguments[_key73];
    }

    _this73 = _super73.call.apply(_super73, [this].concat(params));
    _this73.name = 'VerificationMessageCannotBeBlank';
    _this73.message = 'Verification message cannot be blank.';
    _this73.status = statusCodes['Bad Request'];
    return _this73;
  }

  return VerificationMessageCannotBeBlank;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var VerificationMessageMustBeString = /*#__PURE__*/function (_Error74) {
  _inherits(VerificationMessageMustBeString, _Error74);

  var _super74 = _createSuper(VerificationMessageMustBeString);

  function VerificationMessageMustBeString() {
    var _this74;

    _classCallCheck(this, VerificationMessageMustBeString);

    for (var _len74 = arguments.length, params = new Array(_len74), _key74 = 0; _key74 < _len74; _key74++) {
      params[_key74] = arguments[_key74];
    }

    _this74 = _super74.call.apply(_super74, [this].concat(params));
    _this74.name = 'VerificationMessageMustBeString';
    _this74.message = 'Verification message must be a string.';
    _this74.status = statusCodes['Bad Request'];
    return _this74;
  }

  return VerificationMessageMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var VerificationMessageInvalid = /*#__PURE__*/function (_Error75) {
  _inherits(VerificationMessageInvalid, _Error75);

  var _super75 = _createSuper(VerificationMessageInvalid);

  function VerificationMessageInvalid(maxLength) {
    var _this75;

    _classCallCheck(this, VerificationMessageInvalid);

    for (var _len75 = arguments.length, params = new Array(_len75 > 1 ? _len75 - 1 : 0), _key75 = 1; _key75 < _len75; _key75++) {
      params[_key75 - 1] = arguments[_key75];
    }

    _this75 = _super75.call.apply(_super75, [this, maxLength].concat(params));
    _this75.name = 'VerificationMessageInvalid';
    _this75.message = 'Verification message invalid.';
    _this75.status = statusCodes['Bad Request'];
    return _this75;
  }

  return VerificationMessageInvalid;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var VerifyingSelfNotAllowed = /*#__PURE__*/function (_Error76) {
  _inherits(VerifyingSelfNotAllowed, _Error76);

  var _super76 = _createSuper(VerifyingSelfNotAllowed);

  function VerifyingSelfNotAllowed(maxLength) {
    var _this76;

    _classCallCheck(this, VerifyingSelfNotAllowed);

    for (var _len76 = arguments.length, params = new Array(_len76 > 1 ? _len76 - 1 : 0), _key76 = 1; _key76 < _len76; _key76++) {
      params[_key76 - 1] = arguments[_key76];
    }

    _this76 = _super76.call.apply(_super76, [this, maxLength].concat(params));
    _this76.name = 'VerifyingSelfNotAllowed';
    _this76.message = 'Verifying self not allowed. Can only verify other users.';
    _this76.status = statusCodes['Bad Request'];
    return _this76;
  }

  return VerifyingSelfNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ProgressHandlerMustBeFunction = /*#__PURE__*/function (_Error77) {
  _inherits(ProgressHandlerMustBeFunction, _Error77);

  var _super77 = _createSuper(ProgressHandlerMustBeFunction);

  function ProgressHandlerMustBeFunction() {
    var _this77;

    _classCallCheck(this, ProgressHandlerMustBeFunction);

    for (var _len77 = arguments.length, params = new Array(_len77), _key77 = 0; _key77 < _len77; _key77++) {
      params[_key77] = arguments[_key77];
    }

    _this77 = _super77.call.apply(_super77, [this].concat(params));
    _this77.name = 'ProgressHandlerMustBeFunction';
    _this77.message = 'Progress handler must be a function.';
    _this77.status = statusCodes['Bad Request'];
    return _this77;
  }

  return ProgressHandlerMustBeFunction;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var TransactionUnauthorized = /*#__PURE__*/function (_Error78) {
  _inherits(TransactionUnauthorized, _Error78);

  var _super78 = _createSuper(TransactionUnauthorized);

  function TransactionUnauthorized(command) {
    var _this78;

    _classCallCheck(this, TransactionUnauthorized);

    for (var _len78 = arguments.length, params = new Array(_len78 > 1 ? _len78 - 1 : 0), _key78 = 1; _key78 < _len78; _key78++) {
      params[_key78 - 1] = arguments[_key78];
    }

    _this78 = _super78.call.apply(_super78, [this, command].concat(params));
    _this78.name = 'TransactionUnauthorized';
    _this78.message = "Calling '".concat(command, "' on this item is unauthorized.");
    _this78.status = statusCodes['Forbidden'];
    return _this78;
  }

  return TransactionUnauthorized;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var WriteAccessParamNotAllowed = /*#__PURE__*/function (_Error79) {
  _inherits(WriteAccessParamNotAllowed, _Error79);

  var _super79 = _createSuper(WriteAccessParamNotAllowed);

  function WriteAccessParamNotAllowed(command) {
    var _this79;

    _classCallCheck(this, WriteAccessParamNotAllowed);

    for (var _len79 = arguments.length, params = new Array(_len79 > 1 ? _len79 - 1 : 0), _key79 = 1; _key79 < _len79; _key79++) {
      params[_key79 - 1] = arguments[_key79];
    }

    _this79 = _super79.call.apply(_super79, [this, command].concat(params));
    _this79.name = 'WriteAccessParamNotAllowed';
    _this79.message = "Write access parameter not allowed. Only the item creator or database owner can change an item's write access settings.";
    _this79.status = statusCodes['Forbidden'];
    return _this79;
  }

  return WriteAccessParamNotAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export default {
  DatabaseNameMissing: DatabaseNameMissing,
  DatabaseNameCannotBeBlank: DatabaseNameCannotBeBlank,
  DatabaseNameMustBeString: DatabaseNameMustBeString,
  DatabaseNameTooLong: DatabaseNameTooLong,
  DatabaseNameRestricted: DatabaseNameRestricted,
  DatabaseNotFound: DatabaseNotFound,
  DatabaseIsReadOnly: DatabaseIsReadOnly,
  DatabaseAlreadyOpening: DatabaseAlreadyOpening,
  DatabaseIdMustBeString: DatabaseIdMustBeString,
  DatabaseIdCannotBeBlank: DatabaseIdCannotBeBlank,
  DatabaseIdNotAllowed: DatabaseIdNotAllowed,
  DatabaseIdNotAllowedForOwnDatabase: DatabaseIdNotAllowedForOwnDatabase,
  DatabaseIdInvalidLength: DatabaseIdInvalidLength,
  ShareTokenInvalid: ShareTokenInvalid,
  ShareTokenNotFound: ShareTokenNotFound,
  ShareTokenNotAllowed: ShareTokenNotAllowed,
  ShareTokenNotAllowedForOwnDatabase: ShareTokenNotAllowedForOwnDatabase,
  ReadOnlyMustBeBoolean: ReadOnlyMustBeBoolean,
  ReadOnlyParamNotAllowed: ReadOnlyParamNotAllowed,
  ResharingAllowedMustBeBoolean: ResharingAllowedMustBeBoolean,
  ResharingNotAllowed: ResharingNotAllowed,
  ResharingWithWriteAccessNotAllowed: ResharingWithWriteAccessNotAllowed,
  ResharingAllowedParamNotAllowed: ResharingAllowedParamNotAllowed,
  SharingWithSelfNotAllowed: SharingWithSelfNotAllowed,
  ModifyingOwnPermissionsNotAllowed: ModifyingOwnPermissionsNotAllowed,
  ModifyingOwnerPermissionsNotAllowed: ModifyingOwnerPermissionsNotAllowed,
  ModifyingPermissionsNotAllowed: ModifyingPermissionsNotAllowed,
  GrantingWriteAccessNotAllowed: GrantingWriteAccessNotAllowed,
  RequireVerifiedMustBeBoolean: RequireVerifiedMustBeBoolean,
  RequireVerifiedParamNotNecessary: RequireVerifiedParamNotNecessary,
  RevokeMustBeBoolean: RevokeMustBeBoolean,
  ChangeHandlerMissing: ChangeHandlerMissing,
  ChangeHandlerMustBeFunction: ChangeHandlerMustBeFunction,
  EncryptionModeNotValid: EncryptionModeNotValid,
  ServerSideEncryptionNotEnabledInClient: ServerSideEncryptionNotEnabledInClient,
  DatabaseNotOpen: DatabaseNotOpen,
  ItemMissing: ItemMissing,
  ItemInvalid: ItemInvalid,
  ItemTooLarge: ItemTooLarge,
  ItemIdMustBeString: ItemIdMustBeString,
  ItemIdTooLong: ItemIdTooLong,
  ItemIdMissing: ItemIdMissing,
  ItemIdCannotBeBlank: ItemIdCannotBeBlank,
  ItemAlreadyExists: ItemAlreadyExists,
  ItemDoesNotExist: ItemDoesNotExist,
  ItemUpdateConflict: ItemUpdateConflict,
  FileMissing: FileMissing,
  FileMustBeFile: FileMustBeFile,
  FileCannotBeEmpty: FileCannotBeEmpty,
  FileUploadConflict: FileUploadConflict,
  FileNotFound: FileNotFound,
  FileIdMissing: FileIdMissing,
  FileIdMustBeString: FileIdMustBeString,
  FileIdCannotBeBlank: FileIdCannotBeBlank,
  FileIdTooLong: FileIdTooLong,
  RangeMustBeObject: RangeMustBeObject,
  RangeMissingStart: RangeMissingStart,
  RangeMissingEnd: RangeMissingEnd,
  RangeStartMustBeNumber: RangeStartMustBeNumber,
  RangeEndMustBeNumber: RangeEndMustBeNumber,
  RangeStartMustBeGreaterThanZero: RangeStartMustBeGreaterThanZero,
  RangeEndMustBeGreaterThanRangeStart: RangeEndMustBeGreaterThanRangeStart,
  RangeEndMustBeLessThanFileSize: RangeEndMustBeLessThanFileSize,
  OperationsMissing: OperationsMissing,
  OperationsMustBeArray: OperationsMustBeArray,
  OperationsConflict: OperationsConflict,
  OperationsExceedLimit: OperationsExceedLimit,
  CommandNotRecognized: CommandNotRecognized,
  UserNotVerified: UserNotVerified,
  UserMustBeReverified: UserMustBeReverified,
  UserUnableToReceiveDatabase: UserUnableToReceiveDatabase,
  VerificationMessageMissing: VerificationMessageMissing,
  VerificationMessageMustBeString: VerificationMessageMustBeString,
  VerificationMessageCannotBeBlank: VerificationMessageCannotBeBlank,
  VerificationMessageInvalid: VerificationMessageInvalid,
  VerifyingSelfNotAllowed: VerifyingSelfNotAllowed,
  ProgressHandlerMustBeFunction: ProgressHandlerMustBeFunction,
  TransactionUnauthorized: TransactionUnauthorized,
  WriteAccessParamNotAllowed: WriteAccessParamNotAllowed
};